const runIfIsFunction = (candidateFunction) => {
  if (candidateFunction && typeof candidateFunction === "function") {
    candidateFunction();
  }
};

export default runIfIsFunction;
